module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG4994564ff8beadbb354a02357ab27d75.4994564f.png";